export const MATCHING_LIST = [
    {caption: 'Email', required: true},
    {caption: 'First name'},
    {caption: 'Last name'},
];
export const UPLOAD_FILE_MAX_SIZE_LIMIT_MB = 100;
export const MAX_RECORD_SIZE = 1001;
export const UPLOAD_LOGIN_LINK_GENERATOR_TEMPLATE = '/static/Generate-login-link-template.csv';
